import { render, staticRenderFns } from "./wrongExamResult.vue?vue&type=template&id=6196a1e0&scoped=true"
import script from "./wrongExamResult.vue?vue&type=script&lang=js"
export * from "./wrongExamResult.vue?vue&type=script&lang=js"
import style0 from "./wrongExamResult.vue?vue&type=style&index=0&id=6196a1e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6196a1e0",
  null
  
)

export default component.exports